import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PurchaseService = {
  // Define your API functions here
  // getList: async () => {
  //   const response = await apiService.get("/purchases");
  //   return response.data;
  // },

  getList: async ({
    pageNumber = 1,
    perPage = 10,
    fromDate = "",
    toDate = "",
    SearchText = "",
  } = {}) => {
    const params = new URLSearchParams({
      ...(SearchText && { SearchText: SearchText.toString() }),
      ...(fromDate && { fromDate }),
      ...(toDate && { toDate }),
      Page: pageNumber.toString(),
      PageSize: perPage.toString(),
    });
    try {
      const res = await apiService.get(`/purchases?${params.toString()}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return res.data;
    } catch (err) {
      console.log("Error getting order list. ERR:", err);
      throw err;
    }
  },

  create: async (postData) => {
    const response = await apiService.post("/purchases", postData, {
      headers: {
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },

  detail: async (id) => {
    const response = await apiService.get(`/purchases/${id}`, {
      headers: {
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/purchases/${id}`, {
      headers: {
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/purchases/${id}`, updatedData, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  markBillPaid: async (id) => {
    try {
      const response = await apiService.put(
        `/purchases/mark-bill-paid/${id}`,
        {}, // Empty body since you don't need to send any data
        {
          headers: {
            Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error marking bill as paid:", error);
      throw error;
    }
  },
};

export default PurchaseService;
